// extracted by mini-css-extract-plugin
export default {"brandPrimary":"#017eb7","colorGray":"#777"};